import React from "react";
import TrcaEpcModule from "@/pages/modules/TrcaEpcModule";

export default function TrcaEpcPage() {
  return (
    <div className="min-h-screen bg-background">
      <TrcaEpcModule />
    </div>
  );
}
